'use strict'
var menus = angular.module('menusModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	'ngBootstrap',
	'ui.tree',
	'slugifier',
	'color.picker'
]).config(['$provide',function($provide) {
	$provide.decorator('ColorPickerOptions',['$delegate', function($delegate) {
		var options = angular.copy($delegate);
		options.round = false;
		options.alpha = false;
		options.format = 'hexString';
		options.saturation = false;
		options.reset = {
			show: false
		};
		options.close = {
			show:  true
		};
		options.allowEmpty = true;
		return options;
	}]);
}]);;
require('./menus/js/directive/menusDirective.js')(menus);
require('./menus/js/menusController.js')(menus);
require('./menus/js/directive/checkedWidgetDirective.js')(menus);
require('./menus/js/directive/checkedListMenuDirective.js')(menus);





//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/menusModule/menusModule.js
// module id = 525
// module chunks = 0